import { render } from "./PagoEnBanco.vue?vue&type=template&id=ac2bedc2"
import script from "./PagoEnBanco.vue?vue&type=script&lang=js"
export * from "./PagoEnBanco.vue?vue&type=script&lang=js"

import "./PagoEnBanco.vue?vue&type=style&index=0&id=ac2bedc2&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__